/**
 * 移动组织模态框组件
 * 负责组织的移动功能
 */

import React, { useState } from "react";
import { Modal, Select } from "antd";

const MoveOrganizationModal = ({
    visible,
    selectedOrganization,
    organizationTree,
    onCancel,
    onConfirm
}) => {
    const [moveTargetOrg, setMoveTargetOrg] = useState(null);

    // 获取可选的父组织列表
    const getParentOptions = (tree, excludeId = null) => {
        const options = [];
        const traverse = (nodes) => {
            nodes.forEach((node) => {
                if (node.id !== excludeId) {
                    options.push({ value: node.id, label: node.name });
                    if (node.children) {
                        traverse(node.children);
                    }
                }
            });
        };
        traverse(tree);
        return options;
    };

    // 处理取消
    const handleCancel = () => {
        setMoveTargetOrg(null);
        onCancel();
    };

    // 处理确认
    const handleConfirm = () => {
        if (moveTargetOrg !== null) {
            onConfirm(selectedOrganization.id, moveTargetOrg);
            setMoveTargetOrg(null);
        }
    };

    return (
        <Modal
            title={`移动组织 ${selectedOrganization?.name}`}
            open={visible}
            onCancel={handleCancel}
            onOk={handleConfirm}
            okText="确认移动"
            cancelText="取消"
            okButtonProps={{
                disabled: moveTargetOrg === null
            }}
        >
            <div style={{ marginBottom: 16 }}>选择新的父组织：</div>
            <Select
                placeholder="选择父组织"
                style={{ width: "100%" }}
                value={moveTargetOrg}
                onChange={setMoveTargetOrg}
                options={getParentOptions(organizationTree, selectedOrganization?.id)}
            />
        </Modal>
    );
};

export default MoveOrganizationModal;
